/* globals FormData */

import context from '../context'
import { CancelToken } from '@/utils/fetch'

const maxFileSize = 1024 * 1024 * 100

let cancellation = null

const initialState = {
  queue: [], // list of file's uuid queued to for upload (file with index 0 is currently uploading file
  files: {},
  uploadProgress: null // if not null, file with index 0 is just uploading
}

const actionTypes = {
  fileUpload: 'fileService/fileUpload', // used to add new files to upload into queue
  fileUploading: 'fileService/fileUploading', // used to update uploading progress
  fileUploaded: 'fileService/fileUploaded', // when upload is successfully completed
  fileUploadError: 'fileService/fileUploadError',
  removeFile: 'fileService/removeFile'
}

const actionCreators = {
  upload: (files, onFilesAddedCallback) => (dispatch, getState) => {
    dispatch({ type: actionTypes.fileUpload, files })
    setTimeout(() => uploadFile(dispatch, getState, onFilesAddedCallback), 0)
  },
  remove: (uuid) => (dispatch) => {
    dispatch({ type: actionTypes.removeFile, uuid })
  },
  cancel: (uuid) => (dispatch, getState) => {
    const uploadingUuid = getState().fileService.queue[0]
    if (uploadingUuid === uuid && cancellation) { // cancel file upload
      cancellation.cancel('File upload canceled by the user.')
    } // else just remove it from queue
    dispatch({ type: actionTypes.removeFile, uuid })
  }
}

function uploadFile (dispatch, getState, onFilesAddedCallback) {
  const state = getState().fileService
  if (state.uploadProgress !== null) return // some file is already uploading

  const uuid = state.queue[0]
  if (!uuid) { // no files in the queue
    onFilesAddedCallback()
    return
  }
  const fileToUpload = state.files[uuid]
  if (!fileToUpload) { // no such file
    dispatch({ type: actionTypes.fileUploadError, uuid, error: 'No such UUID' })
    setTimeout(() => uploadFile(dispatch, getState, onFilesAddedCallback), 0)
    return
  }

  if (fileToUpload.size > maxFileSize) {
    // dispatch({ type: actionTypes.fileUploadError, uuid, error: 'Common.FileSizeExceeded' })
    // return
  }
  // lets start the upload
  dispatch({ type: actionTypes.fileUploading, progress: 0 })

  const data = new FormData()
  data.append('file', fileToUpload, fileToUpload.name)
  cancellation = CancelToken.source()

  context.api.file.put({
    name: fileToUpload.name,
    contentType: fileToUpload.contentType,
    length: fileToUpload.size
  }, uuid).then(() => context.api.file.upload(data, uuid, {
    cancelToken: cancellation.token,
    onUploadProgress: function (progressEvent) {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
      if (percentCompleted < 100) {
        dispatch({ type: actionTypes.fileUploading, progress: percentCompleted })
      }
    }
  })).then(() => {
    dispatch({ type: actionTypes.fileUploaded, uuid })
    setTimeout(() => uploadFile(dispatch, getState, onFilesAddedCallback), 0)
  }).catch(() => {
    dispatch({ type: actionTypes.fileUploadError, error: 'Common.FileUploadFailed', uuid })
    setTimeout(() => uploadFile(dispatch, getState, onFilesAddedCallback), 0)
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fileUpload: {
      let toEnqueue = []
      let files = { ...state.files }
      action.files.forEach(f => {
        const existingFile = state.files[f.id]
        if (!existingFile) {
          toEnqueue.push(f.id)
        } else {
          f = { ...existingFile, ...f }
        }
        files[f.id] = f
      })
      state = {
        ...state,
        queue: [...state.queue, ...toEnqueue],
        files: files
      }
      break
    }
    case actionTypes.fileUploading: {
      return { ...state, uploadProgress: action.progress }
    }
    case actionTypes.fileUploaded: {
      let files = { ...state.files }
      delete files[action.uuid]

      state = {
        ...state,
        queue: state.queue.slice(1),
        uploadProgress: null,
        files
      }
      break
    }
    case actionTypes.fileUploadError: {
      state = {
        ...state,
        queue: [...state.queue.slice(1)],
        uploadProgress: null,
        files: {
          ...state.files,
          [action.uuid]: {
            ...state.files[action.uuid],
            error: action.error
          }
        }
      }
      break
    }
    case actionTypes.removeFile: {
      const isUploading = state.queue[0] === action.uuid
      let files = { ...state.files }
      delete files[action.uuid]
      state = {
        ...state,
        queue: state.queue.filter(x => x !== action.uuid),
        files: files,
        uploadProgress: isUploading ? null : state.uploadProgress
      }
      break
    }
    default: break
  }
  return state
}

export {
  actionTypes,
  actionCreators,
  reducer
}



// WEBPACK FOOTER //
// ./src/store/FileService.js